import styled from 'styled-components/macro';
import { Loader as LoaderComponent } from '@redis-ui/components';

export const Loader = styled(LoaderComponent)`
  height: 100vh;
`;
